<template>
  <div class="home data-panel-home">
    <Header title="账号收益"></Header>
    <div class="wechat-revenue wechat-panel">
      <el-date-picker
        class="wechat-data"
        v-model="selectDate"
        type="date"
        placeholder="选择日期"
        @change="changeDate"
      >
      </el-date-picker>

      <div class="wechat-revenue-info">
        <!-- revenues -->
        <el-table
          v-if="revenues && revenues.length"
          :data="revenues"
          stripe
          style="width: 100%"
        >
          <el-table-column
            prop="email"
            label="账号"
            align='center'
          >
          </el-table-column>
          <el-table-column
            prop="outBytes"
            align='center'
            label="使用带宽"
          >
           <template slot-scope="scope">
             <span v-if="scope.row.outBytes">{{ scope.row.outBytes }} Mbps</span>
             <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-else class="wechat-revenue-nodata">暂无收益</div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import Header from "@/WechatComponents/Header.vue";
const WECHAT_HOST = "https://open.weixin.qq.com/connect/oauth2/authorize";
import { getCookie } from "@/utils/utils";
import { Message } from "element-ui";
import moment from "moment";
const selectDate = moment()
        .utc()
        .startOf("day")
        .subtract(1, "days")
        .format("YYYY-MM-DD");

export default {
  name: "home",
  components: {
    Header
  },
  data() {
    return {
      email: "",
      password: "",
      selectDate
    };
  },
  computed: mapState({
    openid: state => state.wechat.openid,
    emails: state => state.wechat.emails,
    revenues: state => state.wechat.revenues
  }),
  created() {
    try {
      let that = this;
      
      let openid = getCookie("openid") || this.$route.query.openid;

      let redirect_url =
        this.$route.query.redirect_url ||
        "https%3a%2f%2fconsole.bonuscloud.work%2fwechat%2frevenue";
      let appid = this.$route.query.appid || "wx95ccc89810c1da7f";
      let code = this.$route.query.code;

      if (openid || code) {
        this.openId = openid;

        this.getWechatInfo({ openid, code, type: "revenue", selectDate });
      } else {
        window.location.href = `${WECHAT_HOST}?appid=${appid}&redirect_uri=${redirect_url}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
      }
    } catch (error) {
      alert(error);
    }
  },
  methods: {
    ...mapActions(["getWechatInfo", "bindWechatEmail"]),
    changeDate() {
      let that = this;
      let { selectDate, openid } = this;
      this.getWechatInfo({ openid, type: "revenue", selectDate });
    },
   
  }
};
</script>

<style scoped lang="stylus">
.data-panel-home.home {
  height: auto !important;
}

.wechat-home {
  background: #fff;
  text-align: center;
  padding: 20px;
}

.bind-email-wrap {
  padding: 30px 20px;
  background: #fff;
  text-align: center;
}

.wechat-bind-email {
  margin: 20px 0;
}

.wechat-bind-email {
  margin-top: 20px;
}

.wechat-panel {
  background: #fff;
}

.wechat-data {
  margin: 20px;
}

.wechat-revenue-nodata{
  text-align: center;
  color: #909399;
}
</style>

